import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../states/containers/store'

import { CompanyExternalApiKey } from '../../../../states/types/setting'
import { format } from '../../../../utils/date'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Tips from '../../../components/common/Tips'
import { useTranslation } from 'react-i18next'

interface ExternalApiKeyItemProps {
  companyExternalApiKey: CompanyExternalApiKey
  openEditModal: (companyExternalApiKey: CompanyExternalApiKey) => void
  openDetailModal: (companyExternalApiKey: CompanyExternalApiKey) => void
  openDeleteModal: (companyExternalApiKey: CompanyExternalApiKey) => void
}

const ExternalApiKeyItem: FC<ExternalApiKeyItemProps> = (props) => {
  const {
    companyExternalApiKey,
    openEditModal,
    openDetailModal,
    openDeleteModal,
  } = props
  const { t } = useTranslation()

  const {
    errors,
  } = useSelector((state: RootState) => (state))

  return (
    <tr>
      <td>
        <div
          style={{
            display: "flex",
          }}
        >
          <div>
            <Tips
              description={t('setting.externalApiKey.editExternalApiKey')}
              className=""
              icon={false}
            >
              <button
                type="button"
                onClick={() => openEditModal(companyExternalApiKey)}
              >
                <FontAwesomeIcon icon={['fas', 'tools']} />
              </button>
            </Tips>
          </div>

          <div>
            <Tips
              description={t('setting.externalApiKey.detailExternalApiKey')}
              className=""
              icon={false}
            >
              <button
                type="button"
                onClick={() => openDetailModal(companyExternalApiKey)}
              >
                <FontAwesomeIcon icon={['fas', 'key']} />
              </button>
            </Tips>
          </div>

          <div>
            <Tips
              description={t('setting.externalApiKey.deleteExternalApiKey')}
              className=""
              icon={false}
            >
              <button
                type="button"
                className="del"
                onClick={() => openDeleteModal(companyExternalApiKey)}
              >
                <FontAwesomeIcon icon={['fas', 'trash-alt']} />
              </button>
            </Tips>
          </div>

        </div>
      </td>
      <td>
        <div> { companyExternalApiKey.label } </div>
      </td>
      <td>
        <div>
          { companyExternalApiKey.last_used_at
            ? format(companyExternalApiKey.last_used_at, "YYYY年MM月DD日 HH:mm:ss")
            : '-'
          }
        </div>
      </td>
      <td>
        <div>
          { companyExternalApiKey.created_at
            ? format(companyExternalApiKey.created_at, "YYYY年MM月DD日 HH:mm:ss")
            : '-'
          }
        </div>
      </td>
      <td>
        <div>
          { companyExternalApiKey.creator?.name }
        </div>
      </td>
    </tr>
  )
}

export default ExternalApiKeyItem
